import React from "react";
import Header from "./Header";
import Footer2 from "./Footer2";

const Terms = () => {
  return (
    <>
      {/* Header Start */} <Header />
      {/* Header End */}


      <div className="terms-main">
        <div className="container">
          <div className="terms-inner">
            <h1 className="terms-title"> Terms and Conditions</h1>
            <p className="terms-date">Effective Date: 16/10/2025</p>
            <p className="terms-intro">
              Welcome to <strong>vvdesign.in</strong>. These Terms and Conditions govern your use of our website. By using our Site, you agree to be bound by these Terms.
            </p>

            <div className="terms-section">
              <h3>1. Use of the Site</h3>
              <p>You agree to use the Site only for lawful purposes.</p>
            </div>

            <div className="terms-section">
              <h3>2. Products and Services</h3>
              <p>
                We offer handcrafted art, craft supplies, and digital downloads. Product descriptions and prices are subject to change without notice. We reserve the right to limit the quantity of products sold.
              </p>
            </div>

            <div className="terms-section">
              <h3>3. Orders and Payment</h3>
              <ul>
                <li>All prices are in Indian currency.</li>
                <li>Payments are processed securely through third-party platforms.</li>
                <li>We reserve the right to refuse or cancel any order.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>4. Shipping and Returns</h3>
              <ul>
                <li>Shipping costs and times vary by location.</li>
                <li>Returns are accepted within 7 days for eligible items only.</li>
                <li>Digital downloads and custom-made items are non-refundable.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>5. Intellectual Property</h3>
              <p>
                All content on the Site — including images, text, logos, and designs — is the property of <strong>vvdesign.in</strong> or its content creators. You may not use, reproduce, or distribute content without written permission.
              </p>
            </div>

            <div className="terms-section">
              <h3>6. User Content</h3>
              <p>
                If you submit reviews, comments, or images, you grant us the right to use, reproduce, and publish them for promotional purposes.
              </p>
            </div>

            <div className="terms-section">
              <h3>7. Prohibited Activities</h3>
              <ul>
                <li>Hack or interfere with the site's security.</li>
                <li>Use bots or scraping tools.</li>
                <li>Post offensive or unlawful content.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>8. Limitation of Liability</h3>
              <ul>
                <li>We are not liable for any indirect or consequential damages.</li>
                <li>We are not responsible for loss of data, revenue, or profits.</li>
                <li>We are not liable for errors in product descriptions or delays in shipping.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>9. Governing Law</h3>
              <p>These Terms are governed by the laws of India, without regard to conflict of law principles.</p>
            </div>

            <div className="terms-section">
              <h3>10. Contact Us</h3>
              <p>
                For questions or concerns, contact us at: <br />
                <strong>
                  📧
                  <a
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=vvdesign.64@gmail.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: 'black', textDecoration: 'none' }}
                    className="hover:underline"
                  >
                    vvdesign.64@gmail.com
                  </a>
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer2 />
    </>

  );
};

export default Terms;
